import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Blogs from "@/pages/Blogs";
import BlogPost from "@/pages/BlogPost";
import VisualEditor from "@/components/site/VisualEditor";
import WhatsAppButton from "@/components/site/WhatsAppButton";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/blog" element={<Blogs />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                </Routes>
            </BrowserRouter>
            <VisualEditor />
            <WhatsAppButton />
            <Toaster position="bottom-right" theme="dark" richColors closeButton />
        </div>
    );
}

export default App;
